import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { Sun, Moon } from 'lucide-react';

/**
 * Botón claro/oscuro para el Sidebar. `next-themes` resuelve el tema en cliente,
 * así que esperamos al montaje para pintar el icono correcto (evita desajuste).
 */
export default function ThemeToggle({ collapsed }: { collapsed?: boolean }) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const isDark = !mounted || theme !== 'light';
  const label = isDark ? 'Tema claro' : 'Tema oscuro';

  return (
    <button
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label={label}
      title={label}
      className={`flex items-center text-pelip-text-faint hover:text-pelip-text-soft transition-colors rounded-lg hover:bg-pelip-bg-elev-2 ${
        collapsed ? 'justify-center w-full h-9' : 'gap-2 w-full px-3 py-2'
      }`}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
      {!collapsed && <span className="text-sm">{label}</span>}
    </button>
  );
}
